import { MessageCircle, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";
import { blogPosts } from "@/data/blogPosts";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";

const Blog = () => {
  const { t, lang } = useLanguage();
  const b = t.blog;

  return (
    <div data-testid="blog-page">
      <Seo
        title={lang === "es" ? "Blog — Guías para moverte por España | Marina Knows" : "Blog — Guides to Navigating Spain | Marina Knows"}
        description={lang === "es"
          ? "Guías en lenguaje claro sobre NIE, TIE, empadronamiento, autónomos, citas previas y alquileres en la Comunidad Valenciana. Próximamente."
          : "Plain-language guides to NIE, TIE, empadronamiento, autónomo registration, cita previa and renting in the Comunidad Valenciana. Coming soon."}
      />

      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-28">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-olive mb-4">{b.overline}</p>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-ink mb-6 max-w-3xl" data-testid="blog-title">{b.title}</h1>
        <p className="text-lg text-ink/70 max-w-2xl mb-16" data-testid="blog-sub">{b.sub}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogPosts.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.05}>
              <Link
                to={`/blog/${post.slug}`}
                data-testid={`blog-post-${post.slug}`}
                className="group block bg-white border border-stone rounded-2xl overflow-hidden h-full flex flex-col hover:-translate-y-1 hover:border-citrus/60 transition-all"
              >
                <img
                  src={`/images/blog/${post.slug}-thumb.jpg`}
                  alt={post.title[lang]}
                  className="w-full h-40 object-cover"
                  loading="lazy"
                />
                <div className="p-8 flex flex-col flex-1">
                  <div className="flex items-center justify-between mb-5">
                    <span className="font-mono text-xs uppercase tracking-[0.2em] text-azul">{post.tag[lang]}</span>
                    <span className="font-mono text-xs text-stone-fg">{post.readTime[lang]}</span>
                  </div>
                  <h2 className="font-serif text-2xl leading-snug text-ink mb-3 group-hover:text-bronze transition-colors">{post.title[lang]}</h2>
                  <p className="text-ink/65 text-sm leading-relaxed mb-4">{post.excerpt[lang]}</p>
                  <ArrowUpRight size={18} className="mt-auto text-citrus" aria-hidden />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="blog-cta"
            className="mt-14 inline-flex items-center gap-2 bg-terracotta hover:bg-terracotta-dark text-ink font-medium px-7 py-3.5 rounded-full transition-all hover:-translate-y-0.5"
          >
            <MessageCircle size={17} aria-hidden />
            {b.cta}
          </a>
        </Reveal>
      </section>
    </div>
  );
};

export default Blog;
